"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InitialiseTableContext = exports.GetFilteredQuotes = exports.DeriveSelectedPlan = void 0;
var _brandConfigs = require("@PetSureAustralia/petsure-brand-partner-configs/distConfigs/brandConfigs");
var _quoteHelpers = require("../../../helpers/quoteHelpers");
var _productTableLabels = require("../../productTableLabels");
var _productHelpers = require("../../../helpers/productHelpers");
var _planHelpers = require("../../../helpers/planHelpers");
var _defaultStaffInstructions = require("../../staffMode/default/defaultStaffInstructions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable no-console */
var GetFilteredQuotes = exports.GetFilteredQuotes = function GetFilteredQuotes(_ref) {
  var productQuotes = _ref.productQuotes,
    tableContext = _ref.tableContext;
  var selectedOptions = tableContext.selectedOptions,
    productGroups = tableContext.ProductGroupsKeyedByPlanNumber,
    AllPlans = tableContext.AllPlans,
    AddOnsMap = tableContext.AddOnsMap;
  if (Object.keys(AllPlans).length > 0) {
    return (0, _quoteHelpers.FilterQuotesByVariations)({
      productQuotes: productQuotes,
      productGroups: productGroups,
      selectedOptions: selectedOptions,
      AllPlans: AllPlans,
      AddOnsMap: AddOnsMap
    });
  }
  ;
  return AllPlans;
};
var DeriveSelectedPlan = exports.DeriveSelectedPlan = function DeriveSelectedPlan(_ref2) {
  var productDefinition = _ref2.productDefinition,
    tableContext = _ref2.tableContext,
    tableState = _ref2.tableState;
  var ProductGroupsKeyedByPlanNumber = tableContext.ProductGroupsKeyedByPlanNumber,
    AllPlans = tableContext.AllPlans,
    AddOnsMap = tableContext.AddOnsMap;
  var selectedOptions = tableState.selectedOptions,
    debugMode = tableState.debugMode,
    productsAreMerged = tableState.productsAreMerged;

  // If the products are merged find the variant that has the required addons
  if (productsAreMerged) {
    var _FindMatchingPlanBase = (0, _planHelpers.FindMatchingPlanBasedOnVariants)({
        productDefinition: productDefinition,
        productGroup: ProductGroupsKeyedByPlanNumber["Plan_".concat(productDefinition.planNumber)],
        AllPlans: AllPlans,
        AddOnsMap: AddOnsMap,
        selectedOptions: selectedOptions
      }),
      selectedProduct = _FindMatchingPlanBase.selectedProduct,
      _selectedAddOns = _FindMatchingPlanBase.selectedAddOns;
    if (debugMode) {
      console.debug('Product derived from variants', 'Selected Product', selectedProduct, 'Selected options', _selectedAddOns);
    }
    return {
      selectedProduct: selectedProduct,
      selectedOptions: _selectedAddOns
    };
  }
  var selectedAddOns = selectedOptions.allPlans[productDefinition.planNumber];
  if (debugMode) {
    console.debug('Product selected directly', 'Selected Product', productDefinition, 'Selected options', selectedAddOns);
  }
  return {
    selectedProduct: productDefinition,
    selectedOptions: selectedAddOns
  };
};

/*
  The productDefinitions are keyed by productGroup.
  Each productGroup is an object keyed by planNo.
  The BaseProducts are ones without the isVariant property.
*/
var InitialiseTableContext = exports.InitialiseTableContext = function InitialiseTableContext(_ref3) {
  var productDefinitions = _ref3.productDefinitions,
    tableLayoutConfiguration = _ref3.tableLayoutConfiguration,
    _ref3$brand = _ref3.brand,
    brand = _ref3$brand === void 0 ? 'pinscom' : _ref3$brand,
    speciesFilter = _ref3.speciesFilter,
    staffMode = _ref3.staffMode,
    petSureStaffMode = _ref3.petSureStaffMode,
    productsAreMerged = _ref3.productsAreMerged,
    quotesContext = _ref3.quotesContext,
    ageFilter = _ref3.ageFilter;
  var _ref4 = _brandConfigs.BrandConfigs[brand] || _brandConfigs.BrandConfigs["default"],
    customStaffInstructions = _ref4.quoteTools.productTable.staffInstructions;
  var brandTextElements = tableLayoutConfiguration || _productTableLabels.ProductTableLabels["default"];
  var staffInstructions = staffMode || petSureStaffMode ? _objectSpread(_objectSpread({}, _defaultStaffInstructions.DefaultStaffInstructions), customStaffInstructions) : {};
  var _TransformProductDefi = (0, _productHelpers.TransformProductDefinitions)({
      productDefinitions: productDefinitions,
      brand: brand,
      speciesFilter: speciesFilter,
      staffMode: staffMode,
      petSureStaffMode: petSureStaffMode,
      brandTextElements: brandTextElements,
      quotesContext: quotesContext,
      ageFilter: ageFilter
    }),
    BaseProducts = _TransformProductDefi.BaseProducts,
    DisplayOrders = _TransformProductDefi.DisplayOrders,
    ProductGroupingsBySpecies = _TransformProductDefi.ProductGroupingsBySpecies,
    ProductGroupsKeyedByPlanNumber = _TransformProductDefi.ProductGroupsKeyedByPlanNumber,
    _TransformProductDefi2 = _TransformProductDefi.AllPlans,
    AllPlans = _TransformProductDefi2 === void 0 ? [] : _TransformProductDefi2,
    AddOnsMap = _TransformProductDefi.AddOnsMap,
    initialPlanOptionsState = _TransformProductDefi.InitialPlanOptionsState,
    FilterProducts = _TransformProductDefi.FilterProducts;
  var groupedProductNames = brandTextElements.groupedProductNames;
  var groupDisplayStates = brandTextElements.labelGroups.reduce(function (acc, group, groupIndex) {
    acc[groupIndex] = group.groupIsVisible || group.groupStyle === 'fixed';
    return acc;
  }, {});
  return {
    brandTextElements: brandTextElements,
    staffInstructions: staffInstructions,
    groupedProductNames: groupedProductNames,
    groupDisplayStates: groupDisplayStates,
    productsAreMerged: productsAreMerged,
    speciesFilter: speciesFilter,
    initialPlanOptionsState: initialPlanOptionsState,
    BaseProducts: BaseProducts,
    FilterProducts: FilterProducts,
    DisplayOrders: DisplayOrders,
    ProductGroupingsBySpecies: ProductGroupingsBySpecies,
    ProductGroupsKeyedByPlanNumber: ProductGroupsKeyedByPlanNumber,
    AllPlans: AllPlans,
    AddOnsMap: AddOnsMap
  };
};